import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth-store';
import { ROUTES } from '@/constants/routes';

export function PublicRoute() {
  const { isAuthenticated, isLocked } = useAuthStore();
  const location = useLocation();

  if (isAuthenticated) {
    if (isLocked) {
      return <Navigate to={ROUTES.UNLOCK} replace />;
    }
    const from = (location.state as { from?: { pathname: string } })?.from?.pathname || ROUTES.DASHBOARD;
    return <Navigate to={from} replace />;
  }

  return <Outlet />;
}
